export default "__VITE_ASSET__546d64e7__"